import Card from '@material-ui/core/Card'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'
import React from 'react'
import Assets from '../../configs/assetConfigs'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#e9f0fe',
    boxShadow: 'inset 0px 0px 0px 0px rgba(0,0,0,0.12)',
    color: '#404040',
    fontSize: 12,
    padding: '20px 25px',
    borderTop: '1px solid #CFCFCF',
    borderRadius: 0,
  },
  icon: {
    marginRight: '5px',
    width: '40px',
  },
}))

export default ({ className, children }) => {
  const classes = useStyles()

  return (
    <Card className={clsx('flex items-center', classes.root, className)}>
      <img
        alt="Publish"
        className={classes.icon}
        src={Assets.megaphoneBgIcon}
      />
      <div className="w-full">{children}</div>
    </Card>
  )
}
